<template>
  <v-row justify="center">
    <v-dialog
      v-model="uploadMessageDialog"
      persistent
      scrollable
      max-width="680px"
    >
      <v-card>
        <v-card-title>ข้อมูลที่อัพโหลดไม่สำเร็จ</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-list-item
            three-line
            v-for="(item, index) in uploadFail"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>บรรทัด : {{ item.line }}</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                {{ item.message_th }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="py-1">
                {{ item.raw_data }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="$emit('handleCloseUploadMessageDialog')"
            >ปิด</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    uploadMessageDialog: {
      type: Boolean,
      default: false,
    },
    uploadFail: {
      type: Array,
    },
  },
}
</script>
